import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useDataBoxSelector } from 'app/common/data-box-store'
import { campSelector as campSelectorDataBox } from 'app/dataProviders/campSelector'
import { CampItem } from 'app/dataTypes/CampSelector'

import selectOrg, { type Org } from './selectOrg'


export default function useSchoolAsCamp(id: number | string, schoolType: string) {
  const studentId = String(id)
  // @ts-ignore
  const org: Org = useSelector(state => selectOrg(state, studentId))

  const getCurrent = () => campSelectorDataBox.getCurrentByStudentId(studentId)
  const current = useDataBoxSelector<CampItem | null>(campSelectorDataBox, getCurrent)

  const school = useMemo(() => {
    return (
      current && schoolType === 'camp'
        ? { id: parseInt(current.id), title: current.schoolTitle, isCamp: true }
        : org
    )
  }, [current, org, schoolType])

  return school
}
